import React from 'react';
import { FormattedMessage } from 'react-intl';
import { appNotification } from '../../containers/App/appNotification';
import { createLocalNotification } from '../../containers/App/utils';

const notification = createLocalNotification('ReservationSamePassengers', {
    error: (
        <FormattedMessage
            id='front-app/ReservationSamePassengers/Notification/Error:title'
            defaultMessage='Check Same Passengers Error'
        />
    ),
});

export const reservationSamePassengersNotifications = {
    unknownError: (details?: JSX.Element | string) => (
        notification.error(appNotification.texts.unknownError(details))
    ),
};
